module.exports = __webpack_public_path__ + "img/q_50_sor.497b747c.png";